import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  ViewChild,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { TituloComponent } from '../../../../shared/components/titulo/titulo.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModalFormService } from '../../../../shared/components/modal-form/service/modal-form.service';
import { ButtonPrimaryComponent } from '../../../../shared/components/button-primary/button-primary.component';
import { ButtonSecondaryComponent } from '../../../../shared/components/button-secondary/button-secondary.component';
import { ErrorMessageComponent } from '../../../../shared/components/error-message/error-message.component';
import { FormLeafletDrawComponent } from '../form-leaflet-draw/form-leaflet-draw.component';
import { VisorgisService } from '../../services/visorgis.service';
import { catchError, finalize, of, tap } from 'rxjs';

@Component({
  selector: 'app-modal-leaflet-draw',
  imports: [
    TituloComponent,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ButtonPrimaryComponent,
    ButtonSecondaryComponent,
    ErrorMessageComponent,
    FormLeafletDrawComponent,
  ],
  templateUrl: './modal-leaflet-draw.component.html',
  styleUrl: './modal-leaflet-draw.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalLeafletDrawComponent implements AfterViewInit {
  @ViewChild('formParcela') formParcela: FormLeafletDrawComponent;
  isIphone: any;
  titulo = 'Crear una nueva parcela';
  subtitulo = 'Asigna un nombre a tu parcela e indica su referencia catastral.';
  isLoading = signal(false);
  error = signal(null);
  created = signal(false);
  labelPrimaryButton = 'Crear parcela';
  labelSecundaryButton = computed(() =>
    this.created() ? 'Cerrar' : 'Cancelar'
  );

  disabledPrimaryButton = signal(true);
  createParcelaId = signal(null);

  constructor(
    public modalFormService: ModalFormService,
    private visorgisService: VisorgisService
  ) {}

  ngAfterViewInit(): void {
    this.modalFormService.showingModal.subscribe((value: boolean) => {
      if (!value) {
        console.log('Cerrar!!!!!!!!');

        this.created.set(false);
        this.error.set(null);
      }
    });
  }

  cancelar() {
    this.created.set(false);
    this.error.set(null);
    this.createParcelaId() ? null : this.visorgisService.cancelDraw.next(true);
    this.createParcelaId.set(null);
    this.modalFormService.closeDrawer.next(true);
  }

  isValidForm(value): any {
    this.disabledPrimaryButton.set(!value);
  }

  guardar() {
    this.isLoading.set(true);
    const geometry = this.visorgisService.createParcelaGeometry;
    const { name, ref_catastral } = this.formParcela.getFormValue();
    console.log({ geometry, name, ref_catastral });
    this.visorgisService
      .createParcela({ geometry, name, ref_catastral })
      .pipe(
        tap(data => {
          // TODO: modificar esta funcion acorde a la respuesta del backend
          if (data) {
            this.createParcelaId.set(data);
            this.created.set(true);
            this.error.set(null);
            this.visorgisService.createdParcela.next(true);
          }
        }),
        catchError(e => {
          this.error.set(
            e.error.detail ||
              e.error.message ||
              'No se pudo crear la parcela, por favor reintenar más tarde o cargar una consulta en Soporte.'
          );
          console.log(e);

          return of(e.message);
        }),
        finalize(() => this.isLoading.set(false))
      )
      .subscribe();
  }

  verParcelaOdoo() {
    this.visorgisService.goToOdoo(this.createParcelaId(), 'parcela');
  }
}
